export const QuotesStatusKeys = {
  WAITING: 'waiting',
  RECEIVED: 'received',
  APPROVED: 'approved',
  DENIED: 'denied',
  WITHDRAWN: 'withdrawn',
  ACR: 'acr',
};



// WEBPACK FOOTER //
// ./src/domain/quotes-status-enum.js